<template lang="pug">
v-fade-transition(mode="out-in")
  v-tooltip(:bottom="!$vuetify.rtl")
    template(#activator="{ on, attrs }")
      v-icon(
        v-bind="attrs"
        v-on="on"
        @click="switchTheme()"
      )
        | {{ $vuetify.theme.dark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}

    span
      span.text-md.font-weight-medium Esquema de Cores
      br
      span.font-weight-light Alterna entre os esquemas de cores claro e escuro.
</template>

<script>
import { SET_DARK } from "@/store/mutation-types";
import { mdiWeatherNight, mdiWeatherSunny } from "@mdi/js";

export default {

  data: () => ({
    icons: {
      mdiWeatherNight,
      mdiWeatherSunny,
    },
  }),

  methods: {
    switchTheme() {
      const dark = !this.$vuetify.theme.dark
      this.$vuetify.theme.dark = dark
      this.$store.commit(SET_DARK, dark)
    },
  },
};
</script>

<style>
</style>
